/* ==========================================================================
   TheLashBrowShop — theme JS (vanilla, no build step)
   Converted from the approved HTML demo; demo data/localStorage replaced by
   Shopify's cart + product APIs.
   ========================================================================== */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- helpers ---------- */
  var cfg = window.TLBS || { routes: {}, strings: {} };
  var moneyFmt;
  try { moneyFmt = new Intl.NumberFormat('de-DE', { style: 'currency', currency: cfg.currency || 'EUR' }); }
  catch (err) { moneyFmt = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }); }
  function money(cents) { return moneyFmt.format((cents || 0) / 100); }   // always "18,90 €"

  function esc(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // Shopify CDN resizes via &width= (same as Liquid's image_url: width:)
  function imgUrl(src, width) {
    if (!src) return '';
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  var toastTimer;
  function toast(msg) {
    var el = $('[data-toast]');
    if (!el) return;
    el.textContent = msg;
    el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-visible'); }, 2600);
  }

  /* ---------- Scroll reveal ---------- */
  var revealObserver = ('IntersectionObserver' in window && !reduceMotion)
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); revealObserver.unobserve(e.target); } });
      }, { rootMargin: '0px 0px -8% 0px' })
    : null;
  function observeReveals(ctx) {
    $$('.reveal:not(.is-in)', ctx).forEach(function (el) {
      if (revealObserver) revealObserver.observe(el); else el.classList.add('is-in');
    });
  }
  observeReveals(document);

  /* ---------- SECTION: announcement-bar (marquee pause toggle) ---------- */
  $$('[data-marquee]').forEach(function (bar) {
    var btn = $('[data-marquee-toggle]', bar);
    if (!btn) return;
    btn.addEventListener('click', function () {
      var paused = bar.classList.toggle('is-paused');
      btn.setAttribute('aria-label', paused ? 'Laufschrift fortsetzen' : 'Laufschrift anhalten');
    });
  });

  /* ---------- SECTION: header (shrink on scroll) ---------- */
  var header = $('[data-header]');
  var sentinel = $('[data-header-sentinel]');
  if (header && sentinel && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      header.classList.toggle('is-scrolled', !entries[0].isIntersecting);
    }).observe(sentinel);
  }

  /* ---------- mobile search toggle ---------- */
  var searchToggle = $('[data-search-toggle]');
  var searchPanel = $('#search-panel');
  if (searchToggle && searchPanel) {
    searchToggle.addEventListener('click', function () {
      var open = searchPanel.hidden;
      searchPanel.hidden = !open;
      searchToggle.setAttribute('aria-expanded', String(open));
      if (open) $('input', searchPanel).focus();
    });
  }

  /* ---------- SECTION: header — mega menu (hover + click + keyboard) ---------- */
  var megaNav = $('[data-mega-nav]');
  if (megaNav) {
    var triggers = $$('button[aria-controls]', megaNav);
    var hoverTimer;
    var canHover = window.matchMedia('(hover: hover)').matches;

    var closeAll = function (except) {
      triggers.forEach(function (t) {
        if (t === except) return;
        t.setAttribute('aria-expanded', 'false');
        document.getElementById(t.getAttribute('aria-controls')).classList.remove('is-open');
      });
    };
    var open = function (t) {
      closeAll(t);
      t.setAttribute('aria-expanded', 'true');
      document.getElementById(t.getAttribute('aria-controls')).classList.add('is-open');
    };

    triggers.forEach(function (t) {
      var item = t.parentElement;
      var panel = document.getElementById(t.getAttribute('aria-controls'));

      t.addEventListener('click', function () {
        if (t.getAttribute('aria-expanded') === 'true') closeAll(); else open(t);
      });
      t.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown') {
          e.preventDefault(); open(t);
          var first = $('a', panel); if (first) first.focus();
        }
      });
      if (canHover) {
        item.addEventListener('mouseenter', function () {
          clearTimeout(hoverTimer);
          hoverTimer = setTimeout(function () { open(t); }, 90);
        });
        item.addEventListener('mouseleave', function () {
          clearTimeout(hoverTimer);
          hoverTimer = setTimeout(function () { closeAll(); }, 160);
        });
      }
      item.addEventListener('focusout', function (e) {
        if (!item.contains(e.relatedTarget)) {
          t.setAttribute('aria-expanded', 'false');
          panel.classList.remove('is-open');
        }
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var openBtn = triggers.filter(function (t) { return t.getAttribute('aria-expanded') === 'true'; })[0];
      if (openBtn) { closeAll(); openBtn.focus(); }
    });
    document.addEventListener('click', function (e) {
      if (!megaNav.contains(e.target)) closeAll();
    });
  }

  /* ---------- Drawers (menu-drawer + cart-drawer) ---------- */
  var lastFocus = null;
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select, summary, [tabindex]:not([tabindex="-1"])';

  function openDrawer(id) {
    var drawer = document.getElementById(id);
    if (!drawer || drawer.classList.contains('is-open')) return;
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-locked');
    $$('[data-drawer-open="' + id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    var closeBtn = $('.drawer-head [data-drawer-close]', drawer);
    setTimeout(function () { (closeBtn || drawer).focus(); }, 50);
  }
  function closeDrawer(drawer) {
    if (!drawer || !drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('is-locked');
    $$('[data-drawer-open="' + drawer.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) { e.preventDefault(); openDrawer(opener.getAttribute('data-drawer-open')); return; }
    var closer = e.target.closest('[data-drawer-close]');
    if (closer) closeDrawer(closer.closest('[data-drawer]'));
  });
  document.addEventListener('keydown', function (e) {
    var drawer = $('[data-drawer].is-open');
    if (!drawer) return;
    if (e.key === 'Escape') { closeDrawer(drawer); return; }
    if (e.key === 'Tab') {
      var items = $$(FOCUSABLE, $('.drawer-panel', drawer)).filter(function (el) { return el.offsetParent !== null; });
      if (!items.length) return;
      var first = items[0], last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ---------- SECTION: hero-slider (crossfade; the CSS progress bar drives autoplay) ---------- */
  $$('[data-slider]').forEach(function (slider) {
    var slides = $$('[data-slide]', slider);
    var tabs = $$('[data-slider-dot]', slider);
    var index = 0;

    function goTo(i) {
      index = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) {
        var active = n === index;
        s.classList.toggle('is-active', active);
        s.setAttribute('aria-hidden', active ? 'false' : 'true');
        if ('inert' in s) s.inert = !active;
      });
      tabs.forEach(function (t, n) {
        t.setAttribute('aria-current', n === index ? 'true' : 'false');
        var bar = $('.hero-tab__bar span', t);         // restart the progress animation
        bar.style.animation = 'none'; void bar.offsetWidth; bar.style.animation = '';
      });
    }
    // when the active tab's progress bar finishes, advance (pausing the animation pauses autoplay)
    tabs.forEach(function (t) {
      $('.hero-tab__bar span', t).addEventListener('animationend', function () {
        if (t.getAttribute('aria-current') === 'true') goTo(index + 1);
      });
      t.addEventListener('click', function () { goTo(+t.getAttribute('data-slider-dot')); });
    });
    var prev = $('[data-slider-prev]', slider), next = $('[data-slider-next]', slider);
    if (prev) prev.addEventListener('click', function () { goTo(index - 1); });
    if (next) next.addEventListener('click', function () { goTo(index + 1); });

    var hovering = false, focused = false, inView = true, touched = false, nearTop = true;
    function updatePause() { slider.classList.toggle('is-paused', hovering || focused || touched || !inView || !nearTop || document.hidden); }
    // touch = the visitor is interacting: stop autoplay for this visit (they can still tap the tabs)
    slider.addEventListener('touchstart', function () { touched = true; updatePause(); }, { passive: true });
    // hold the slide once the visitor scrolls down to read it (the stacked mobile hero is taller than the screen)
    window.addEventListener('scroll', function () {
      var top = slider.getBoundingClientRect().top;
      if ((top > -80) !== nearTop) { nearTop = top > -80; updatePause(); }
    }, { passive: true });
    slider.addEventListener('mouseenter', function () { hovering = true; updatePause(); });
    slider.addEventListener('mouseleave', function () { hovering = false; updatePause(); });
    slider.addEventListener('focusin', function () { focused = true; updatePause(); });
    slider.addEventListener('focusout', function (e) { if (!slider.contains(e.relatedTarget)) { focused = false; updatePause(); } });
    document.addEventListener('visibilitychange', updatePause);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) { inView = entries[0].intersectionRatio > 0.4; updatePause(); }, { threshold: [0, 0.4, 1] }).observe(slider);
    }

    // soft magenta spotlight follows the pointer
    var spot = $('.hero-spot', slider), raf = 0;
    if (spot && !reduceMotion && window.matchMedia('(hover: hover)').matches) {
      slider.addEventListener('pointermove', function (e) {
        if (raf) return;
        raf = requestAnimationFrame(function () {
          var r = slider.getBoundingClientRect();
          spot.style.setProperty('--mx', ((e.clientX - r.left) / r.width * 100) + '%');
          spot.style.setProperty('--my', ((e.clientY - r.top) / r.height * 100) + '%');
          raf = 0;
        });
      });
    }
    goTo(0);
  });

  /* ---------- Event countdown ---------- */
  $$('[data-countdown]').forEach(function (el) {
    var target = new Date(el.getAttribute('data-countdown')).getTime();
    var parts = { d: $('[data-cd="d"]', el), h: $('[data-cd="h"]', el), m: $('[data-cd="m"]', el), s: $('[data-cd="s"]', el) };
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var diff = Math.max(0, target - Date.now());
      parts.d.textContent = Math.floor(diff / 864e5);
      parts.h.textContent = pad(Math.floor(diff / 36e5) % 24);
      parts.m.textContent = pad(Math.floor(diff / 6e4) % 60);
      parts.s.textContent = pad(Math.floor(diff / 1e3) % 60);
    }
    tick();
    setInterval(tick, 1000);
  });


  /* ---------- SECTION: brand-carousel ---------- */
  $$('[data-rail]').forEach(function (rail) {
    var section = rail.closest('section');
    var step = function (dir) { rail.scrollBy({ left: dir * rail.clientWidth * 0.8, behavior: reduceMotion ? 'auto' : 'smooth' }); };
    var p = $('[data-rail-prev]', section), n = $('[data-rail-next]', section);
    if (p) p.addEventListener('click', function () { step(-1); });
    if (n) n.addEventListener('click', function () { step(1); });
  });

  /* ---------- SECTION: video-feature (load video only on click) ---------- */
  $$('[data-video-play]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var frame = btn.closest('[data-video]');
      var video = document.createElement('video');
      video.src = btn.getAttribute('data-src');
      video.controls = true;
      video.playsInline = true;
      video.setAttribute('aria-label', 'Korean Lash Lift – Video @deborahortler');
      frame.innerHTML = '';
      frame.appendChild(video);
      video.play().catch(function () {});
      video.focus();
    });
  });


  /* ---------- auto-submitting selects (country selector) ---------- */
  document.addEventListener('change', function (e) {
    var el = e.target;
    if (el.matches('[data-autosubmit]')) { (el.form || document.getElementById(el.getAttribute('form'))).submit(); }
  });

  /* ==========================================================================
     Collection filters / sort / pagination without a page reload.
     Section Rendering API: fetch this section only (…&section_id=…), swap the
     filters + results, update the URL. Without JS the form still submits normally.
     ========================================================================== */
  var collectionRoot = $('[data-collection]');
  if (collectionRoot) {
    var sectionId = collectionRoot.getAttribute('data-section-id');
    var filterForm = $('[data-filter-form]', collectionRoot);
    var fetchCtrl = null;

    var buildUrl = function () {
      var params = new URLSearchParams(new FormData(filterForm));   // includes the sort select (form="filters")
      // drop empty price fields so the URL stays clean
      Array.from(params.keys()).forEach(function (k) { if (params.get(k) === '') params.delete(k); });
      var qs = params.toString();
      return filterForm.getAttribute('action') + (qs ? '?' + qs : '');
    };

    var render = function (url, opts) {
      opts = opts || {};
      if (fetchCtrl) fetchCtrl.abort();
      fetchCtrl = 'AbortController' in window ? new AbortController() : null;
      var results = $('[data-collection-results]', collectionRoot);
      results.classList.add('is-loading');
      results.setAttribute('aria-busy', 'true');
      var sep = url.indexOf('?') > -1 ? '&' : '?';
      return fetch(url + sep + 'section_id=' + encodeURIComponent(sectionId), fetchCtrl ? { signal: fetchCtrl.signal } : {})
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var freshForm = doc.querySelector('[data-filter-form]');
          var freshResults = doc.querySelector('[data-collection-results]');
          var freshCount = doc.querySelector('[data-collection-count]');
          if (!freshResults) { location.href = url; return; }

          // filters: keep open/closed groups and keyboard focus as they were
          if (freshForm) {
            var openState = $$('details', filterForm).map(function (d) { return d.open; });
            var focusedName = document.activeElement && filterForm.contains(document.activeElement) ? document.activeElement.name + '|' + document.activeElement.value : null;
            filterForm.innerHTML = freshForm.innerHTML;
            $$('details', filterForm).forEach(function (d, i) { if (openState[i] !== undefined) d.open = openState[i]; });
            if (focusedName) {
              var again = $$('input', filterForm).filter(function (i) { return i.name + '|' + i.value === focusedName; })[0];
              if (again) again.focus();
            }
            bindPriceInputs();
          }
          results.innerHTML = freshResults.innerHTML;
          var count = $('[data-collection-count]', collectionRoot);
          if (count && freshCount) count.textContent = freshCount.textContent;
          // new cards fade in right away (don't wait for the scroll observer)
          void results.offsetHeight;
          $$('.reveal', results).forEach(function (el) { el.classList.add('is-in'); });

          if (opts.push !== false) history.pushState({ tlbsCollection: true }, '', url);
          if (opts.scrollToResults) {
            var top = collectionRoot.getBoundingClientRect().top + window.scrollY - 170;
            if (window.scrollY > top) window.scrollTo({ top: top, behavior: reduceMotion ? 'auto' : 'smooth' });
          }
        })
        .catch(function (err) { if (!err || err.name !== 'AbortError') location.href = url; })
        .then(function () { results.classList.remove('is-loading'); results.removeAttribute('aria-busy'); });
    };

    // checkboxes + sort: update immediately
    collectionRoot.addEventListener('change', function (e) {
      var el = e.target;
      if (el.type === 'number') return;
      if (el.closest('[data-filter-form]') || el.matches('[data-sort]')) render(buildUrl());
    });
    // price fields: wait until typing pauses
    var bindPriceInputs = function () {
      $$('input[type="number"]', filterForm).forEach(function (input) {
        var t;
        input.addEventListener('input', function () { clearTimeout(t); t = setTimeout(function () { render(buildUrl()); }, 800); });
      });
    };
    bindPriceInputs();
    filterForm.addEventListener('submit', function (e) { e.preventDefault(); render(buildUrl()); });

    // "Zurücksetzen", "Filter zurücksetzen" and page numbers
    collectionRoot.addEventListener('click', function (e) {
      var link = e.target.closest('.filters-head a, .empty-state a, .pagination a');
      if (!link || e.metaKey || e.ctrlKey || e.shiftKey) return;
      e.preventDefault();
      render(link.getAttribute('href'), { scrollToResults: !!link.closest('.pagination') });
    });

    // browser back / forward
    window.addEventListener('popstate', function () { render(location.pathname + location.search, { push: false }); });
  }

  var filterToggle = $('[data-filter-toggle]');
  if (filterToggle) {
    filterToggle.addEventListener('click', function () {
      var form = $('#filters');
      var open = form.classList.toggle('is-open');
      filterToggle.setAttribute('aria-expanded', String(open));
    });
  }

  /* ==========================================================================
     Cart — Shopify AJAX API (/cart.js, /cart/add.js, /cart/change.js)
     One document-level handler drives both the drawer and the /cart page.
     ========================================================================== */
  var cartBusy = false;

  function cartError(msg) {
    var el = $('[data-cart-error]');
    if (!el) { toast(msg); return; }
    el.textContent = msg;
    el.hidden = !msg;
  }

  function renderCart(cart) {
    // error responses ({status, message, description}) must never wipe the drawer
    if (!cart || typeof cart.item_count !== 'number') return;
    var count = cart.item_count;
    $$('[data-cart-count]').forEach(function (el) {
      if (String(count) !== el.textContent && count > 0) { el.classList.remove('is-bump'); void el.offsetWidth; el.classList.add('is-bump'); }
      el.textContent = count; el.setAttribute('data-count', count);
    });
    var heading = $('[data-cart-heading-count]');
    if (heading) heading.textContent = count ? '(' + count + ')' : '';

    var list = $('[data-cart-items]');
    if (list) {
      list.innerHTML = cart.items.map(function (i) {
        var variant = (i.product_has_only_default_variant || !i.variant_title) ? '' : '<p class="cart-item__variant">' + esc(i.variant_title) + '</p>';
        return '<li class="cart-item" data-key="' + esc(i.key) + '">' +
          (i.image ? '<img class="cart-item__img" src="' + esc(imgUrl(i.image, 200)) + '" width="92" height="92" alt="" loading="lazy">' : '<span class="cart-item__img"></span>') +
          '<div>' +
            '<p class="cart-item__vendor">' + esc(i.vendor) + '</p>' +
            '<a class="cart-item__title" href="' + esc(i.url) + '">' + esc(i.product_title) + '</a>' + variant +
            '<div class="cart-item__row">' +
              '<div class="qty">' +
                '<button type="button" data-action="dec" aria-label="Menge von ' + esc(i.product_title) + ' verringern">−</button>' +
                '<input type="number" min="0" value="' + i.quantity + '" data-qty-input aria-label="Menge ' + esc(i.product_title) + '" inputmode="numeric">' +
                '<button type="button" data-action="inc" aria-label="Menge von ' + esc(i.product_title) + ' erhöhen">+</button>' +
              '</div>' +
              '<span class="cart-item__price">' + money(i.final_line_price) + '</span>' +
            '</div>' +
            '<button class="cart-item__remove" type="button" data-action="remove">Entfernen</button>' +
          '</div>' +
        '</li>';
      }).join('');
    }
    var empty = $('[data-cart-empty]'); if (empty) empty.hidden = count > 0;
    var foot = $('[data-cart-foot]'); if (foot) foot.hidden = count === 0;
    $$('[data-cart-subtotal]').forEach(function (el) { el.textContent = money(cart.total_price); });

    renderDiscounts(cart);

    var ship = $('[data-free-ship]');
    var threshold = cfg.freeShippingCents || 0;
    if (ship && threshold > 0) {
      var remaining = Math.max(0, threshold - cart.total_price);
      var pct = Math.min(100, Math.round(cart.total_price / threshold * 100));
      ship.classList.toggle('is-reached', remaining === 0);
      var where = cfg.freeShippingWhere || 'innerhalb Deutschlands';
      $('[data-free-ship-text]', ship).innerHTML = remaining === 0
        ? '<strong>Glückwunsch!</strong> Dein Versand ' + where + ' ist kostenlos.'
        : 'Noch <strong>' + money(remaining) + '</strong> bis zum kostenlosen Versand ' + where;
      var bar = $('.progress', ship);
      bar.setAttribute('aria-valuenow', pct);
      $('span', bar).style.width = pct + '%';
    }

    // /cart page: patch lines in place; reload when it empties so the empty state shows
    var page = $('[data-cart-page]');
    if (page) {
      if (count === 0) { location.reload(); return; }
      cart.items.forEach(function (i) {
        var line = page.querySelector('.cart-item[data-key="' + i.key + '"]');
        if (!line) return;
        $('[data-qty-input]', line).value = i.quantity;
        $('.cart-item__price', line).textContent = money(i.final_line_price);
      });
      $$('.cart-item', page).forEach(function (line) {
        var still = cart.items.some(function (i) { return i.key === line.getAttribute('data-key'); });
        if (!still) line.remove();
      });
    }
  }

  // ---- Rabattcode (Cart API: POST /cart/update.js {discount: "CODE"}) ----
  function codeDiscounts(cart) {
    var out = {};
    (cart.cart_level_discount_applications || []).forEach(function (d) {
      if (d.type === 'discount_code') out[d.title] = (out[d.title] || 0) + d.total_allocated_amount;
    });
    (cart.items || []).forEach(function (i) {
      (i.line_level_discount_allocations || []).forEach(function (a) {
        var d = a.discount_application || {};
        if (d.type === 'discount_code') out[d.title] = (out[d.title] || 0) + a.amount;
      });
    });
    return Object.keys(out).map(function (title) { return { title: title, amount: out[title] }; });
  }

  function renderDiscounts(cart) {
    var applied = codeDiscounts(cart);
    $$('[data-discount-list]').forEach(function (list) {
      list.innerHTML = applied.map(function (d) {
        return '<li><span class="cart-discount__code">' + esc(d.title) + '</span>' +
          '<span class="cart-discount__amount">−' + money(d.amount) + '</span>' +
          '<button type="button" data-discount-remove aria-label="Rabattcode ' + esc(d.title) + ' entfernen">×</button></li>';
      }).join('');
    });
  }

  function discountMessage(text, isError) {
    $$('[data-discount-msg]').forEach(function (el) {
      el.textContent = text || '';
      el.hidden = !text;
      el.classList.toggle('is-error', !!isError);
    });
  }

  function setDiscount(code) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: code })
    }).then(function (r) { return r.json(); });
  }

  function applyDiscount(code) {
    if (cartBusy) return;
    var wanted = (code || '').trim();
    if (!wanted) return;
    cartBusy = true;
    discountMessage('');
    fetchCart().then(function (before) {
      var previous = (before.discount_codes || []).filter(function (d) { return d.applicable; }).map(function (d) { return d.code; })[0] || '';
      return setDiscount(wanted).then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); }).then(function (cart) {
        var entry = (cart.discount_codes || []).filter(function (d) { return d.code.toLowerCase() === wanted.toLowerCase(); })[0];
        if (entry && entry.applicable) {
          renderCart(cart);
          discountMessage('Rabattcode ' + entry.code + ' wurde angewendet.', false);
          $$('[data-discount-input]').forEach(function (i) { i.value = ''; });
          return;
        }
        // not applicable: put the previous code back so nothing is lost
        return (previous ? setDiscount(previous) : Promise.resolve()).then(function () {
          return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c2) {
            renderCart(c2);
            discountMessage('Dieser Code ist leider nicht gültig — er kann abgelaufen sein, bereits benutzt worden sein oder sich nicht mit einer anderen Aktion in deinem Warenkorb kombinieren lassen.', true);
          });
        });
      });
    }).catch(function () {
      discountMessage('Der Code konnte gerade nicht geprüft werden. Bitte versuch es noch einmal.', true);
    }).then(function () { cartBusy = false; });
  }

  function removeDiscount() {
    if (cartBusy) return;
    cartBusy = true;
    discountMessage('');
    setDiscount('').then(function () { return fetchCart(); }).catch(function () {}).then(function () { cartBusy = false; });
  }

  document.addEventListener('click', function (e) {
    var apply = e.target.closest('[data-discount-submit]');
    if (apply) {
      e.preventDefault();
      var wrap = apply.closest('[data-cart-discount]');
      applyDiscount($('[data-discount-input]', wrap).value);
      return;
    }
    var rm = e.target.closest('[data-discount-remove]');
    if (rm) { e.preventDefault(); removeDiscount(); }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' || !e.target.matches('[data-discount-input]')) return;
    e.preventDefault();
    applyDiscount(e.target.value);
  });

  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) { renderCart(cart); return cart; });
  }

  function addToCart(body, button) {
    if (cartBusy) return Promise.resolve();
    cartBusy = true;
    cartError('');
    if (button) button.setAttribute('aria-busy', 'true');
    return fetch(cfg.routes.cartAdd || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok) {
          openDrawer('cart-drawer');
          cartError(res.data.description || res.data.message || cfg.strings.cartError || 'Artikel konnte nicht hinzugefügt werden.');
          return fetchCart();
        }
        return fetchCart().then(function () { openDrawer('cart-drawer'); });
      })
      .catch(function () { toast(cfg.strings.cartError || 'Etwas ist schiefgelaufen.'); })
      .then(function () { cartBusy = false; if (button) button.removeAttribute('aria-busy'); });
  }

  function changeLine(key, quantity, focusAfter) {
    cartError('');
    return fetch(cfg.routes.cartChange || '/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok) { cartError(res.data.description || res.data.message || 'Menge konnte nicht geändert werden.'); return fetchCart(); }
        renderCart(res.data);
        if (focusAfter) {
          var btn = $('#cart-drawer .cart-item[data-key="' + key + '"] [data-action="' + focusAfter + '"]');
          (btn || $('#cart-drawer .drawer-head [data-drawer-close]') || document.body).focus();
        }
      });
  }

  // quantity +/- and remove (drawer + /cart page)
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.cart-item [data-action]');
    if (!btn) return;
    e.preventDefault();
    var line = btn.closest('.cart-item');
    var key = line.getAttribute('data-key');
    var cur = parseInt($('[data-qty-input]', line).value, 10) || 0;
    var action = btn.getAttribute('data-action');
    var next = action === 'inc' ? cur + 1 : action === 'dec' ? Math.max(0, cur - 1) : 0;
    changeLine(key, next, action === 'remove' ? null : action);
  });
  document.addEventListener('change', function (e) {
    if (!e.target.matches('.cart-item [data-qty-input]')) return;
    var line = e.target.closest('.cart-item');
    changeLine(line.getAttribute('data-key'), Math.max(0, parseInt(e.target.value, 10) || 0));
  });

  // card quick-add (single-variant products)
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-add-variant]');
    if (!btn) return;
    e.preventDefault();
    addToCart({ items: [{ id: Number(btn.getAttribute('data-add-variant')), quantity: 1 }] }, btn);
  });

  // opening the drawer always shows the live cart
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-drawer-open="cart-drawer"]')) fetchCart();
  }, true);

  /* ==========================================================================
     TEMPLATE: product — variant picker, gallery, add to cart, sticky bar
     ========================================================================== */
  $$('[data-product]').forEach(function (root) {
    var dataEl = $('[data-product-json]', root);
    if (!dataEl) return;
    var data = JSON.parse(dataEl.textContent);
    var form = $('#product-form', root) || $('form[action*="/cart/add"]', root);
    var idInput = $('[data-variant-id]', root);
    var fieldsets = $$('.variant-picker', root);
    var mainImg = $('[data-gallery-main] img', root);
    var thumbs = $$('[data-thumb]', root);
    var index = Math.max(0, thumbs.findIndex(function (t) { return t.getAttribute('aria-current') === 'true'; }));

    function showThumb(i) {
      if (!thumbs.length || !mainImg) return;
      index = (i + thumbs.length) % thumbs.length;
      var t = thumbs[index];
      mainImg.src = t.getAttribute('data-src');
      mainImg.srcset = t.getAttribute('data-srcset');
      mainImg.alt = t.getAttribute('data-alt');
      mainImg.removeAttribute('width'); mainImg.removeAttribute('height');
      thumbs.forEach(function (b, n) { b.setAttribute('aria-current', n === index ? 'true' : 'false'); });
    }
    thumbs.forEach(function (t, n) { t.addEventListener('click', function () { showThumb(n); }); });
    var prev = $('[data-gallery-prev]', root), next = $('[data-gallery-next]', root);
    if (prev) prev.addEventListener('click', function () { showThumb(index - 1); });
    if (next) next.addEventListener('click', function () { showThumb(index + 1); });

    function selectedOptions() {
      return fieldsets.map(function (fs) { var c = $('input:checked', fs); return c ? c.value : null; });
    }
    function tbaText(root) {
      var box = $('[data-product-price]', root);
      return (box && box.getAttribute('data-price-tba')) || '';
    }
    function priceHtml(v, root) {
      // No price entered yet (e.g. an event ticket before the price is fixed): never show 0,00 €.
      var tba = v.price === 0 ? tbaText(root) : '';
      if (tba) return '<span class="price price--tba">' + esc(tba) + '</span>';
      return v.compare_at_price > v.price
        ? '<span class="price price--sale">' + money(v.price) + '</span><s class="price price--compare"><span class="visually-hidden">statt </span>' + money(v.compare_at_price) + '</s><span class="badge badge--sale">Sale</span>'
        : '<span class="price">' + money(v.price) + '</span>';
    }
    function update() {
      var opts = selectedOptions();
      var v = data.variants.filter(function (x) { return x.options.every(function (o, n) { return o === opts[n]; }); })[0];
      fieldsets.forEach(function (fs, n) { var s = $('[data-selected-option]', fs); if (s) s.textContent = opts[n]; });
      $$('[data-add-to-cart]', root).forEach(function (b) {
        b.disabled = !v || !v.available;
        b.textContent = !v ? (cfg.strings.unavailable || 'Nicht verfügbar') : v.available ? (cfg.strings.addToCart || 'In den Warenkorb') : (cfg.strings.soldOut || 'Ausverkauft');
      });
      if (!v) return;
      idInput.value = v.id;
      $('[data-product-price]', root).innerHTML = priceHtml(v, root);
      var sticky = $('[data-product-price-sticky]', root);
      if (sticky) {
        var tba = v.price === 0 ? tbaText(root) : '';
        sticky.innerHTML = '<span class="price">' + (tba ? esc(tba) : money(v.price)) + '</span>';
      }
      var stock = $('[data-product-stock]', root);
      stock.textContent = v.available ? data.inStock : (data.soldOut || 'Derzeit ausverkauft');
      stock.classList.toggle('is-out', !v.available);
      if (v.media_id) {
        var ti = thumbs.findIndex(function (t) { return t.getAttribute('data-media-id') === String(v.media_id); });
        if (ti > -1) showThumb(ti);
      }
      var url = new URL(location.href); url.searchParams.set('variant', v.id);
      history.replaceState(null, '', url.toString());
    }
    fieldsets.forEach(function (fs) { fs.addEventListener('change', update); });

    var qtyWrap = $('[data-product-qty]', root);
    if (qtyWrap) {
      var q = $('input', qtyWrap);
      qtyWrap.addEventListener('click', function (e) {
        if (e.target.closest('[data-qty-plus]')) q.value = (+q.value || 1) + 1;
        if (e.target.closest('[data-qty-minus]')) q.value = Math.max(1, (+q.value || 1) - 1);
      });
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var qty = Math.max(1, parseInt((qtyWrap && $('input', qtyWrap).value) || '1', 10) || 1);
        addToCart({ items: [{ id: Number(idInput.value), quantity: qty }] }, e.submitter || $('[data-add-to-cart]', form));
      });
    }

    // sticky add-to-cart (mobile) — visible once the main buy row scrolls out of view
    var sticky = $('[data-sticky-atc]', root);
    var mainBuy = $('[data-main-buy]', root);
    if (sticky && mainBuy && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var en = entries[0];
        var show = !en.isIntersecting && en.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        $$('button', sticky).forEach(function (b) { b.tabIndex = show ? 0 : -1; });
      }, { rootMargin: '-80px 0px 0px 0px' }).observe(mainBuy);
    }
  });

  /* ---------- related products (Shopify recommendations, section rendering) ---------- */
  $$('[data-related]').forEach(function (el) {
    var url = el.getAttribute('data-url');
    if (!url) return;
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-related]');
      if (!fresh || !fresh.querySelector('.product-grid')) { el.hidden = true; return; }
      el.innerHTML = fresh.innerHTML;
      el.hidden = false;
      observeReveals(el);
    }).catch(function () { el.hidden = true; });
  });

})();
